<template>
<v-list-item @click='$emit("selected", item)' >
  <v-list-item-avatar >
    <v-icon>mdi-clock-outline</v-icon>
    <!-- {{item.id}} -->
  </v-list-item-avatar>
  <v-list-item-content>
    <v-list-item-title >
      {{practitionerName}} @ {{spaceName}}
      <span v-if='locationNames' class='caption' >
        ({{locationNames}})
      </span>
    </v-list-item-title>
    <v-list-item-subtitle class='caption' >
      <span v-for='d in dow' :key='d' >
        <strong v-text='d' />: {{ formatHours(item[d]) }},
      </span>
    </v-list-item-subtitle>
    <v-list-item-subtitle >
      <location-chip
        v-for='addrId in item.addresses' :key='addrId'
        :space-id='item.space'
        :location-id="addrId"
        :attrs='chipAttrs' class='mr-2 mt-2' />
    </v-list-item-subtitle>
  </v-list-item-content>
  <v-list-item-action v-if='withEdit' >
    <v-btn small outlined
      @click.stop='$emit("edit", item)' >Edit
    </v-btn>
  </v-list-item-action>
</v-list-item>
</template>
<script>
import LocationChip from '@/components/listitems/LocationChip.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'GenericListItem',
  components: {LocationChip},
  props: {
    item: { type: Object, required: true},
    withEdit: { type: Boolean, default: false }
  },
  data () {
    return {
      chipAttrs: {
        xSmall: true,
        label: true
      },
      dow: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun']
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById', 'getPractitionerById', 'getLocationBySpaceAndId']),
    spaceId () {
      if (this.item && this.item.space) {
        return this.item.space
      }
      return null
    },
    spaceName () {
      if (this.spaceId) {
        return this.getSpaceName(this.item.space)
      }
      return ''
    },
    practitionerName () {
      if (this.item && this.item.practitioner) {
        let p = this.getPractitionerById(this.item.practitioner)
        if (p.full_name) { return p.full_name }
      }
      return ''
    },
    locationNames () {
      if (this.item.addresses && this.item.addresses > 0) {
        let names = this.item.addresses.map((addrId) => {
          let loc = this.getLocationBySpaceAndId(this.spaceId, addrId)
          if (loc) {
            return loc.name
          }
        })
        if (names) { return names.join(', ') }
      }
      return ''
    }
  },
  methods: {
    getSpaceName (spaceId) {
      let s = this.getSpaceById(spaceId)
      if (s) {
        return s.title
      }
      return spaceId
    },
    formatHours (hrs) {
      if (hrs) {
        return hrs.split('|').join(', ')
      }
      return 'not available'
    }
  }
}
</script>
